export default __webpack_public_path__ + "static/progress2-81970525152af95bea48802afe8cabf2.mp4";